module.exports = __webpack_public_path__ + "static/media/JIBSWAP-logo-mark-dark-color.6c481905.svg";